import ModalLayout from 'components/Modals/ModalLayout';
import SelectCompetitorPanel from 'components/SelectCompetitor';

import { ModalLayoutProps } from '..';

const SelectCompetitorModal = ({ visible, onClose }: ModalLayoutProps) => {
    return (
        <>
            <ModalLayout visible={visible} onClose={onClose}>
                <div className="h-screen w-screen bg-white fixed left-0 top-0 overflow-scroll pt-[30px]">
                    <div className="absolute right-2 top-2 cursor-pointer text-[18px] leading-[20px]" onClick={onClose}>
                        {'✖'}
                    </div>
                    <SelectCompetitorPanel />
                </div>
            </ModalLayout>
        </>
    );
};

export default SelectCompetitorModal;
